import { render, staticRenderFns } from "./RecordMessage.vue?vue&type=template&id=54f41ede&scoped=true&"
import script from "./RecordMessage.vue?vue&type=script&lang=js&"
export * from "./RecordMessage.vue?vue&type=script&lang=js&"
import style0 from "./RecordMessage.vue?vue&type=style&index=0&id=54f41ede&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f41ede",
  null
  
)

export default component.exports